import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconLandingPageSeo = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
      <path
        d="M23.5075 23.1577V25.5119C23.5075 25.7815 23.289 26 23.0195 26H2.48806C2.21851 26 2 25.7815 2 25.5119V4.48806C2 4.21851 2.21851 4 2.48806 4H23.0195C23.289 4 23.5075 4.21851 23.5075 4.48806V7.19921"
        stroke="#28354D"
      />
      <path
        d="M10.493 9.54313L5.7953 14.7556C5.67752 14.8862 5.67752 15.0981 5.7953 15.2288L10.493 20.4412"
        stroke="#4285F4"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M22.2336 9.54313L26.9313 14.7556C27.049 14.8862 27.049 15.0981 26.9313 15.2288L22.2336 20.4412"
        stroke="#4285F4"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M13.1328 18.8203L19.8396 11.3786"
        stroke="#4285F4"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </SvgIcon>
  ))
);
